import React from 'react';
import BlankLayoutWithSidebar from '@/layouts/BlankLayoutWithSidebar';

/**
 * This is the layout used for Classrooms page only.
 */
const ClassroomsLayout = ({ children }: { children?: React.ReactNode }) => {
  return <BlankLayoutWithSidebar backgroundColorClassname="bg-white">{children}</BlankLayoutWithSidebar>;
};

export default ClassroomsLayout;
